import { useRedeemersTradeStats } from "#/services/kyan/hooks/useTradeStats";
import { useReferralsByAccount } from "#/services/referrals/hooks/useReferralsByAccount";

export const useOverviewController = () => {
  const { redeemers, isLoading } = useReferralsByAccount();
  const {
    data: { referralsSummary },
  } = useRedeemersTradeStats(redeemers);

  return {
    data: [{ ...referralsSummary }],
    isLoading,
  };
};
